import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import NavBar from "./NavBar";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import OfferingPage from "./pages/OfferingPage";
import MinistriesPage from "./pages/MinistriesPage";
import SermonsPage from "./pages/SermonsPage";
import JoinPage from "./pages/JoinPage";
import TeamPage from "./pages/TeamPage";
import DeclarationPage from "./pages/DeclarationPage";
import FAQPage from "./pages/FAQPage";
import EventsPage from "./pages/EventsPage";
import ExpectationPage from "./pages/ExpectationPage";
import WomenMinistryPage from "./pages/WomenMinistryPage";
import StudentMinistryPage from "./pages/StudentMinistryPage";
import ChildrenMinistryPage from "./pages/ChildrenMinistryPage";
import CommunitySchoolPage from "./pages/CommunitySchoolPage";
import DiscipleshipPage from "./pages/DiscipleshipPage";
import GospelMinistryPage from "./pages/GospelMinistryPage";
import Joshua2022Page from "./pages/Joshua2022Page";
import Romans2022Page from "./pages/Romans2022Page";
import Mark2023Page from "./pages/Mark2023Page";
import Genesis2020Page from "./pages/Genesis2020Page";
import OtherSermonsPage from "./pages/OtherSermonsPage";
import ImageEditPage from "./pages/ImageEditPage";
import PreviewShell from "./edit/PreviewShell";
import { PageContentProvider } from "./edit/PreviewModeContext";

function App() {
  const location = useLocation();
  // Hide the top-level NavBar for every /edit* route. /edit/preview/:pageId
  // renders its own NavBar nested inside PreviewShell's PreviewProvider so
  // nav links can stay in preview mode when clicked.
  const hideNav = location.pathname.startsWith("/edit");

  return (
    <>
      {!hideNav && <NavBar />}
      <Routes>
        <Route
          path="/"
          element={
            <PageContentProvider pageId="home">
              <HomePage />
            </PageContentProvider>
          }
        />
        <Route path="/about" element={<PageContentProvider pageId="about"><AboutPage /></PageContentProvider>} />
        <Route path="/offering" element={<PageContentProvider pageId="offering"><OfferingPage /></PageContentProvider>} />
        <Route path="/ministries" element={<PageContentProvider pageId="ministries"><MinistriesPage /></PageContentProvider>} />
        <Route path="/sermons" element={<PageContentProvider pageId="sermons"><SermonsPage /></PageContentProvider>} />
        <Route path="/join" element={<PageContentProvider pageId="join"><JoinPage /></PageContentProvider>} />
        <Route path="/team" element={<PageContentProvider pageId="team"><TeamPage /></PageContentProvider>} />
        <Route path="/declaration" element={<PageContentProvider pageId="declaration"><DeclarationPage /></PageContentProvider>} />
        <Route path="/faq" element={<PageContentProvider pageId="faq"><FAQPage /></PageContentProvider>} />
        <Route path="/events" element={<PageContentProvider pageId="events"><EventsPage /></PageContentProvider>} />
        <Route path="/expectation" element={<PageContentProvider pageId="expectation"><ExpectationPage /></PageContentProvider>} />
        <Route path="/women-ministry" element={<PageContentProvider pageId="women-ministry"><WomenMinistryPage /></PageContentProvider>} />
        <Route
          path="/student-ministry"
          element={
            <PageContentProvider pageId="student-ministry">
              <StudentMinistryPage />
            </PageContentProvider>
          }
        />
        <Route path="/children-ministry" element={<PageContentProvider pageId="children-ministry"><ChildrenMinistryPage /></PageContentProvider>} />
        <Route path="/community-school" element={<PageContentProvider pageId="community-school"><CommunitySchoolPage /></PageContentProvider>} />
        <Route path="/discipleship" element={<PageContentProvider pageId="discipleship"><DiscipleshipPage /></PageContentProvider>} />
        <Route path="/gospel-ministry" element={<PageContentProvider pageId="gospel-ministry"><GospelMinistryPage /></PageContentProvider>} />
        <Route path="/joshua-2022" element={<PageContentProvider pageId="joshua-2022"><Joshua2022Page /></PageContentProvider>} />
        <Route path="/romans-2022" element={<PageContentProvider pageId="romans-2022"><Romans2022Page /></PageContentProvider>} />
        <Route path="/mark-2023" element={<PageContentProvider pageId="mark-2023"><Mark2023Page /></PageContentProvider>} />
        <Route path="/genesis-2020" element={<PageContentProvider pageId="genesis-2020"><Genesis2020Page /></PageContentProvider>} />
        <Route path="/other-sermons" element={<PageContentProvider pageId="other-sermons"><OtherSermonsPage /></PageContentProvider>} />
        <Route path="/edit" element={<Navigate to="/edit/preview/home" replace />} />
        <Route path="/edit/images" element={<ImageEditPage />} />
        <Route path="/edit/preview/:pageId" element={<PreviewShell />} />
      </Routes>
    </>
  );
}

export default App;
